import {
  AccountInfo,
  EventMessage,
  EventType,
  PublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";

import { APPENV } from "./env";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

export const msalConfig = {
  auth: {
    clientId: APPENV.AZURE_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${APPENV.AZURE_APP_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
    cacheLocation: "localStorage" as const,
    secureCookies: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: [],
  redirectStartPage: window.location.origin,
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const account: AccountInfo = event?.payload as AccountInfo;
    msalInstance.setActiveAccount(account);
  }
});
